/** Localized time; adds short date when the message is not from the current calendar day. */
export function formatMessageCreatedLabel(
  createdMs: number,
  lang?: string,
): string {
  if (!createdMs || createdMs <= 0) {
    return '';
  }
  const locale = lang ?? undefined;

  return new Intl.DateTimeFormat(locale, {
    hour: 'numeric',
    minute: '2-digit',
  }).format(new Date(createdMs));
}
